import { defineMessages } from 'react-intl';

const messages = defineMessages({
  accountRemovedSuccessfully: {
    defaultMessage: '{name} account removed',
    description: 'Seller Fulfillment provider deletion success body',
    id: 'MrWSI8',
  },
  deleteProvider: {
    defaultMessage: 'Delete {name}',
    description: 'src.pages.settings.providers.delete-modal.title',
    id: 'N9iK5v',
  },
  successNotification: {
    defaultMessage: 'Success!',
    description: 'Seller Fulfillment provider deletion success title',
    id: '2L2iqI',
  },
});

export default messages;
